module.exports = __webpack_public_path__ + "warningNight-fe02d09192aceeeae13e12269ad5f252.png";